import { Outlet } from 'react-router-dom';
import { AuthenticationLayout } from 'components/Layout/AuthenticationLayout';
import { useCognitoUserContext } from 'domains/auth/AWSCognitoWrapper/context';
import { LoginPages } from '../LoginPages/LoginPages';

export const AuthedGate: React.FC = ({ children }) => {
  const { isLoggedIn } = useCognitoUserContext();

  if (!isLoggedIn) {
    return (
      <AuthenticationLayout flashWrapper={false}>
        <LoginPages.Login />
      </AuthenticationLayout>
    );
  }

  return <>{children ?? <Outlet />}</>;
};
